import React from "react";
import {useTranslation} from "../../../context/TranslationsProvider";
import {Link} from "react-router-dom";

const Footer = () => {

    const { translate, language, setLanguage } = useTranslation();

    const currentYear = new Date().getFullYear();


    return (
        <footer className="bg-black flex items-center flex-col justify-center pt-5">
            <div className="container flex flex-col items-center justify-center space-y-5">
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                    alt="Logo"
                    className="h-14 w-auto object-contain"
                />
                <div className="space-x-4 text-orange-100">
                    <Link to="/">{translate("header_home")}</Link>
                    <Link to="/all-paintings">{translate("header_collection")}</Link>
                    <Link to="/about-me">{translate("header_about_me")}</Link>
                    <Link to="/cart">{translate("header_cart")}</Link>
                </div>
                <div className="flex space-x-1">
                    <a href="https://www.instagram.com/ae.paulart" target="_blank" rel="noopener noreferrer">
                        <img src="/assets/icons/instagram.png" alt="Instagram" className="w-14 object-contain align-middle" />
                    </a>
                    <div className="hidden lg:flex space-x-2">
                        <button onClick={() => setLanguage("eng")} className={language === 'eng' ? 'underline header-btn' : 'header-btn'}>
                            EN
                        </button>
                        <button onClick={() => setLanguage("lv")} className={language === 'lv' ? 'underline header-btn' : 'header-btn'}>
                            LV
                        </button>
                        <button onClick={() => setLanguage("ru")} className={language === 'ru' ? 'underline header-btn' : 'header-btn'}>
                            RU
                        </button>
                    </div>
                </div>
                <div>
                    <p className="text-orange-100 text-md mt-10 mb-2">&copy;AnnaElviraPaula | {currentYear}</p>
                </div>
            </div>
            <div className="bg-orange-100 w-full text-center py-2">
                <h1>{translate("footer_made_by")} <a className="underline" href="https://www.linkedin.com/in/niks-k%C4%BCavi%C5%86%C5%A1-5a4832259" target="_blank">Niks Kļaviņš</a> & <a className="underline" href="https://www.linkedin.com/in/m%C4%81rti%C5%86%C5%A1-pauls-6290a3333/" target="_blank">Mārtiņš Pauls</a></h1>
            </div>
        </footer>
    );
};

export default Footer;
